import { hot } from "react-hot-loader/root";
import React from "react";

import TrackListItem from "./TrackListItem.js";
import "./AppleMusic.scss";

class TrackList extends React.Component {
  constructor(props) {
    super(props);

    let totalDurationInMillis = 0;
    this.props.mediaItem.relationships.tracks.data.map(
      track => (totalDurationInMillis += track.attributes.durationInMillis)
    );

    this.state = { totalDurationInMillis: totalDurationInMillis };
  }

  getTime(ms) {
    if (!ms || isNaN(ms)) {
      ms = 0;
    }

    const s = 1000 * Math.round(ms / 1000);
    const d = new Date(s);
    return `${d.getUTCHours()} Hours, ${d.getUTCMinutes()} Minutes`;
  }

  getReleased() {
    let date = new Date(this.props.mediaItem.attributes.releaseDate);
    let released = date.toDateString();
    return released;
  }

  getUpdated() {
    let date = new Date(this.props.mediaItem.attributes.lastModifiedDate);
    let updated = date.toDateString();
    return updated;
  }

  getReleasedOrUpdated() {
    if (this.props.mediaItem.attributes.releaseDate) {
      return (
        <div className="am__tracklist__footer__release">
          Released: {this.getReleased()}
        </div>
      );
    } else {
      return (
        <div className="am__tracklist__footer__release">
          Updated: {this.getUpdated()}
        </div>
      );
    }
  }

  render() {
    let tracks = this.props.mediaItem.relationships.tracks.data.map(
      (track, index) => (
        <TrackListItem
          music={this.props.music}
          track={track}
          index={index}
          key={track.id}
          mediaType={this.props.mediaType}
        />
      )
    );

    let time = this.getTime(this.state.totalDurationInMillis);

    let description = "";
    if (this.props.mediaItem.attributes.description) {
      description = (
        <div className="am__tracklist__editorial">
          <div className="notes">
            {this.props.mediaItem.attributes.description.short}
          </div>
        </div>
      );
    }

    return (
      <div className="am__tracklist playlist top-gradient-visible">
        {description}
        <ul className="am__tracklist__tracks">{tracks}</ul>

        <div className="am__tracklist__footer">
          <div className="am__tracklist__footer__duration">
            {this.props.mediaItem.relationships.tracks.data.length} Songs,{" "}
            {time}
          </div>

          {this.getReleasedOrUpdated()}

          <div className="am__tracklist__footer__copyright">
            {this.props.mediaItem.attributes.copyright}
          </div>
        </div>
      </div>
    );
  }
}

export default hot(TrackList);
